import CommonAutocomplete from "../../../../../components/CommonAutocomplete";
import IntersectionObservedView from "../../../../../components/IntersectionObservedView";

function RankSelect({value, ranks, onSelect, ...prop}) {

  return (
    <IntersectionObservedView
      rootMargin = "50px"
    >
      <CommonAutocomplete
        value={value}
        onSelect={(_e, value) => {
          onSelect(value)
        }}
        data={ranks}
        filterOptions={(options, { inputValue }) => {
          return options.filter((option) => {
            return option.rankId?.toString().includes(inputValue);
          });
        }}
        optionLabel={(option) =>
          option ? option.rankId + " - " + option.rankName : ""
        }
        {...prop}
      />
    </IntersectionObservedView>
  );
}

export default RankSelect;
